import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, MapPin, ShieldCheck } from "lucide-react";
import { businessInfo, navLinks } from "../data/mockData";

const Footer = () => {
  return (
    <footer className="bg-brand-navy text-white pt-16 pb-28 lg:pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="bg-white rounded-xl p-3 inline-block mb-4">
              <img
                src={businessInfo.logoUrl}
                alt="TOFT Gas, Heating & Plumbing"
                className="h-10 w-auto object-contain"
              />
            </div>
            <p className="text-slate-300 text-sm leading-relaxed max-w-md mb-5">
              Gas Safe registered boiler servicing, CP12 landlord gas safety certificates,
              boiler repairs and heating services across <strong className="text-white">Cardiff,
              Pontypridd, Porth, Treorchy, Tonypandy, Llantrisant, Talbot Green, Bridgend,
              Porthcawl and Caerphilly</strong>.
            </p>
            <div className="flex flex-wrap gap-3 text-xs">
              <span className="inline-flex items-center gap-1.5 bg-white/10 px-3 py-1.5 rounded-full">
                <ShieldCheck className="h-3.5 w-3.5 text-brand-blue-light" />
                Gas Safe Registered
              </span>
              <span className="inline-flex items-center gap-1.5 bg-white/10 px-3 py-1.5 rounded-full">
                <MapPin className="h-3.5 w-3.5 text-brand-blue-light" />
                Porth · South Wales
              </span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest text-brand-blue-light mb-4">
              Pages
            </h4>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-slate-300 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest text-brand-blue-light mb-4">
              Contact
            </h4>
            <div className="space-y-3">
              <a
                href={businessInfo.phoneTel}
                className="flex items-center gap-2 text-sm text-white font-semibold hover:text-brand-blue-light transition-colors"
              >
                <Phone className="h-4 w-4" />
                {businessInfo.phone}
              </a>
              <a
                href={businessInfo.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm text-white font-semibold hover:text-brand-blue-light transition-colors"
              >
                <MessageCircle className="h-4 w-4" />
                WhatsApp Available
              </a>
              <p className="text-xs text-slate-400 leading-relaxed pt-2">
                {businessInfo.hoursSummary}<br />
                {businessInfo.emergencyNote}
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-slate-400">
          <p>© {new Date().getFullYear()} TOFT Plumbing Services Ltd. All rights reserved.</p>
          <p>Gas Safe registered engineer covering South Wales.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
